"use client"

import { routes } from "src/config/routes"
import { DetailProductData } from "src/data/product-details/types"
import { LinkedData } from "src/seo/LinkedData"
import { BreadcrumbListItem, createBreadcrumbsLd } from "src/seo/breadcrumbsLd"

const breadcrumbParents: BreadcrumbListItem[] = [
  { name: "Bollerwagen", path: routes.bollerwagen },
  { name: "Laufräder", path: routes.laufraeder },
  { name: "Scooter", path: routes.scooter },
  { name: "Federwiegen", path: routes.federwiegen },
  { name: "B-Ware", path: routes.bStock },
  { name: "Zubehör", path: routes.accessories },
  { name: "Ersatzteile", path: routes.spareParts },
]

export type ProductBreadcrumbsLdProps = {
  name: string
  categories: DetailProductData["categories"]
}

export const ProductBreadcrumbsLd = ({ name, categories }: ProductBreadcrumbsLdProps) => {
  return (
    <>
      {breadcrumbParents.map((parent, index) => {
        if (!categories?.some((category) => category.name === parent.name)) {
          return null
        }
        return <LinkedData key={index} data={createBreadcrumbsLd([parent, { name }])} />
      })}
    </>
  )
}
